import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const UdyamOtpSendInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-send', title: 'Udyam OTP Send', subtitle: 'Initiate OTP send for Udyam (MSME) registration verification' }}
        fields={[
            { name: 'registration_number', label: 'Udyam Registration Number', icon: 'pi-briefcase', placeholder: 'e.g. UDYAM-MH-01-0000001', maxLength: 30, autoCapitalize: 'characters', spellCheck: false, uppercase: true, mono: true },
            { name: 'mobile_number', label: 'Mobile Number', icon: 'pi-phone', placeholder: '9876543210', maxLength: 10, inputMode: 'tel', numeric: true, mono: true,
              regex: /^[6-9]\d{9}$/, regexError: 'Enter a valid 10-digit Indian mobile' },
        ]}
        endpoint={{
            path: '/surepass/udyam-otp/send-otp',
            bodyMapper: (v, sid) => ({ registration_number: v.registration_number, mobile_number: v.mobile_number, api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="udyam-otp-send"
        submitLabel="Send Udyam OTP"
        successSummary="Udyam OTP sent"
        errorSummary="OTP send failed"
        confirmHeader="Confirm Udyam OTP send"
        confirmAcceptLabel="Yes, send"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Udyam OTP Sent', icon: 'pi-send' }}
    />
);

export default UdyamOtpSendInputComponent;
